import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Container,
  IconButton,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/styles";
import React, { useState } from "react";
import ResponsiveLayout from "./ResponsiveLayout";
import ResponsiveDialog from "./ResponsiveDialog";
import Text from "./Text";

export const INFO_PANEL_ID = "info-panel";

export const useAccordionStyles = makeStyles((theme) => ({
  MuiAccordionroot: {
    padding: 0,
    minHeight: 64,
    "&.MuiAccordion-root:before": {
      backgroundColor: "white",
    },
    "&.Mui-expanded": {
      margin: 0,
      marginBottom: 12,
    },
  },
  MuiAccordionSummaryroot: {
    padding: 0,
  },
  MuiAccordionSummaryexpandIcon: {
    color: theme.palette.secondary.main,
    paddingRight: 0,
    paddingLeft: 0,
  },
  MuiAccordionSummarycontent: {
    margin: 0,
    "&.Mui-expanded": {
      margin: 0,
    },
  },
}));

export default function InfoPanel({ infoData }) {
  const classes = useAccordionStyles();
  const isScreenXs = useMediaQuery(useTheme().breakpoints.down("xs"));

  const [state, setState] = useState({
    openInfoPanel: false,
    expandedItem: undefined,
    mode: getMode(),
  });

  const { palette } = useTheme();
  const { openInfoPanel, expandedItem, mode } = state;

  const onOpen = () => {
    setState((s) => ({ ...s, openInfoPanel: true }));
  };

  const onClose = () => {
    setState((s) => ({ ...s, openInfoPanel: false }));
  };

  const onChange = (item) => (event, newItem) => {
    setState((s) => ({ ...s, expandedItem: newItem ? item : false }));
  };

  return (
    <>
      <ResponsiveDialog
        PaperProps={{
          "aria-label": "Information panel",
        }}
        displayCondition={true}
        fullScreenCondition={true}
        open={openInfoPanel}
        onClose={onClose}
      >
        <Container style={{ padding: "1rem 1rem", height: "100%" }}>
          <ResponsiveLayout>
            <Box className="appear-anim">
              <Box my={5}>
                <Typography
                  variant={isScreenXs ? "h6" : "h4"}
                  style={{ color: palette.text.title }}
                >
                  <strong>
                    <Text tId={"HELP"} />
                  </strong>
                </Typography>
              </Box>
              {infoData.map((infoItem, index) => (
                <Accordion
                  key={index}
                  expanded={expandedItem === index}
                  onChange={onChange(index)}
                  elevation={0}
                  classes={{ root: classes.MuiAccordionroot }}
                >
                  <AccordionSummary
                    expandIcon={<i className="material-icons">expand_more</i>}
                    classes={{
                      root: classes.MuiAccordionSummaryroot,
                      expandIcon: classes.MuiAccordionSummaryexpandIcon,
                      content: classes.MuiAccordionSummarycontent,
                    }}
                  >
                    <Typography
                      variant="body2"
                      style={{ color: palette.text.title }}
                    >
                      <strong>{infoItem.title}</strong>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    style={{
                      padding: 0,
                    }}
                  >
                    {infoItem.description}
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          </ResponsiveLayout>
        </Container>
      </ResponsiveDialog>
      {isScreenXs && (
        <IconButton
          id={INFO_PANEL_ID}
          className={"pulse-button"}
          onClick={onOpen}
          style={{
            height: 42,
            width: 42,
            position: "fixed",
            top: mode === "embedded" ? "4px" : "14px",
            right: mode === "embedded" ? "8px" : "54px",
          }}
        >
          <i
            className="material-icons-outlined"
            style={{ color: palette.primary.main }}
          >
            info
          </i>
        </IconButton>
      )}
      {!isScreenXs && (
        <Button
          id={INFO_PANEL_ID}
          className={"pulse-button"}
          variant={"outlined"}
          style={{
            position: "fixed",
            top: "14px",
            right: mode === "embedded" ? "114px" : "64px",
          }}
          onClick={onOpen}
          endIcon={<i className="material-icons-outlined">info</i>}
        >
          <Typography variant={"body2"}>
            <Text tId={"HELP"} />
          </Typography>
        </Button>
      )}
    </>
  );
}

const getMode = () => {
  const mode = new URLSearchParams(window.location.search).get("mode");
  if (mode !== null && ["hosted", "embedded"].includes(mode) === false) {
    throw new Error(`Invalid mode: ${mode}`);
  }
  return mode;
};
